import { FC, useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import useGetExamTestSelectOptions from '@app.feature/exam/gsat2024-2/hooks/useGetExamTermSelectOptions'
import { useExamQuestionInfo } from '@app.feature/exam/hooks/useExamQuestionInfo'
import PredictionInputSelect from '../input/PredictionInputSelect.desktop'
import PredictionFormLabel from '../label/PredictionFormLabel.desktop'

interface IFProps {
  companyId: string
  termId: string
}

const FormItemTestDate: FC<IFProps> = ({ companyId, termId }) => {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  const { testDate, defaultTest } = useExamQuestionInfo({
    companyId,
    termId,
  })

  const { query } = useRouter()
  const selectOptions = useGetExamTestSelectOptions({
    companyId,
    termId,
  })

  const testId = useWatch<TPreReservationFormValues>({
    name: 'testId',
  })

  const defaultSelectOption = selectOptions?.find(
    (option) => option?.value === testId,
  )

  const handleOnChangeTestDate = (value: string) => {
    setValue('testId', value, { shouldValidate: true, shouldDirty: true })
  }

  useEffect(() => {
    if (defaultTest) {
      setValue('testId', testDate?.id ?? defaultTest?.id, {
        shouldValidate: true,
        shouldDirty: true,
      })
    }
  }, [defaultTest, query])

  return (
    <StyledWrapper>
      <PredictionFormLabel label="응시 날짜" />
      <PredictionInputSelect
        placeholder="날짜 선택"
        isErrors={!!errors.testId?.message}
        defaultSelectOption={defaultSelectOption}
        options={selectOptions}
        onChangeSelect={handleOnChangeTestDate}
      />
    </StyledWrapper>
  )
}

export default FormItemTestDate

const StyledWrapper = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
  margin-right: 66px;

  > p {
    width: 85px;
  }

  > div {
    width: 200px;
  }
`
